<template>
	<div class="featured-product">
		<router-link :to="{ name: 'productEdit', params: { id: id } }">
			<div class="image" :style="{ backgroundImage: imageUrl }"></div>
		</router-link>
		<div class="box">
			<router-link class="name" :to="{ name: 'productEdit', params: { id: id } }">
				<div>{{ name }}</div>
				<div class="highlight visible-sm">
					<div class="group" v-if="highlight === 'submissions'">
						<div class="submission-value">{{orders}}</div>
						<div class="submission-label label">{{ $t('Orders') }}</div>
					</div>
					<div class="group" v-if="highlight === 'transaction'">
						<div class="transaction-value">{{paid}}</div>
						<div class="transaction-label label">{{ $t('Paid') }}</div>
					</div>
					<div class="group" v-if="highlight === 'paid-ratio'">
						<div class="paid-ratio-value">{{paidRatio}}%</div>
						<div class="paid-ratio-label label">{{ $t('Paid Ratio') }}</div>
					</div>
					<div class="group" v-if="highlight === 'revenue'">
						<div class="revenue-value">{{revenueDisplay}}</div>
						<div class="revenue-label label">{{ $t('Net Revenue') }}</div>
					</div>
				</div>
			</router-link>
			<!-- <router-link class="name" :to="{ name: 'submissionsProduct', params: { productId: id } }">{{ name }}</router-link> -->
			<div class="submission hidden-sm">
				<div class="submission-value">{{orders}}</div>
				<div class="submission-label">{{ $t('Orders') }}</div>
			</div>
			<div class="transaction hidden-sm">
				<div class="transaction-value">{{paid}}</div>
				<div class="transaction-label">{{ $t('Paid') }}</div>
			</div>
			<div class="paid-ratio hidden-sm">
				<div class="paid-ratio-value">{{paidRatio}}%</div>
				<div class="paid-ratio-label">{{ $t('Paid Ratio') }}</div>
			</div>
			<div class="revenue hidden-sm">
				<div class="revenue-value">{{revenueDisplay}}</div>
				<div class="revenue-label">{{ $t('Net Revenue') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defaultProductImage } from '../lib/statics';

export default {
	name: 'FeaturedProduct',
	props: {
		id: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		image: {
			type: String,
			default: '',
		},
		submission: {
			type: Number,
			default: 0,
		},
		paidRatio: {
			type: Number,
			default: 0,
		},
		revenue: {
			type: Number,
			default: 0,
		},
		transaction: {
			type: Number,
			default: 0,
		},
		highlight: {
			type: String,
			default: '',
		},
	},
	computed: {
		imageUrl() {
			const imageUrl = this.image && this.image !== '' ? this.image : defaultProductImage;
			return `url('${imageUrl}')`;
		},
		revenueDisplay() {
			const revenue = this.revenue || 0;
			return this.formatMoney(revenue);
		},
		orders() {
			return this.submission && this.submission !== '' ? this.submission : 0;
		},
		paid() {
			return this.transaction || 0;
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

.featured-product {
	display: flex;
	border: 1px solid $color__border;
	border-top-width: 0;
	// margin-top: -1px;
	// margin-bottom: 1.5rem;

	&:first-child {
		border-top-width: 1px;

		.image,
		.box {
			border-top-width: 1px;
		}
	}

	.image {
		width: 95px;
		height: 95px;
		background-color: #fff;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		flex-grow: 0;
		flex-shrink: 0;
	}

	.box {
		display: flex;
		margin: 0;
		// width: calc(100% - 95px);
		width: 100%;
		border-radius: 0;
		border: 0;
		border-left: 1px solid $color__border;
		// box-shadow: inset 0 -2px 0 0 $color__cyan;

		@media (max-width: 767px) {
			padding: .7em;
		}
	}

	.name {
		color: inherit;
		// padding-left: 1.5em;
		padding-right: 1em;
		width: 35%;
		text-align: left;
		font-weight: bold;
		// line-height: 55px;
		// white-space: nowrap;
		max-width: 400px;
		overflow: hidden;
		text-overflow: ellipsis;

		&:hover {
			color: $color__cyan-darker;
			text-decoration: none;
		}

		@media (max-width: 767px) {
			padding-left: 0;
			width: 100%;
			max-width: none;
			line-height: 1;
		}
	}

	.highlight {
		margin-top: .7em;

		.label {
			margin-top: 2px;
			font-weight: normal;
		}
	}

	.submission {
		width: 15%;
		text-align: left;
	}

	.transaction {
		width: 15%;
		text-align: left;
	}

	.paid-ratio {
		width: 17%;
		text-align: left;
	}

	.revenue {
		width: 18%;
		text-align: left;
	}

	.submission-value,
	.transaction-value,
	.paid-ratio-value,
	.revenue-value {
		color: $secondary_color;
		font-size: 1.4em;
		font-weight: bold;
	}
}
</style>
